import {
  create_lead_with_oauth_path,
  create_session_with_oauth_path,
  unlock_content_with_oauth_path,
} from '@routes';

import request from './request';

export enum AppleEventName {
  CreateLead = 'createLeadWithApple',
  LogIn = 'logInWithApple',
  UnlockContent = 'unlockContentWithApple',
}

export enum GoogleEventName {
  CreateLead = 'createLeadWithGoogle',
  LogIn = 'logInWithGoogle',
  UnlockContent = 'unlockContentWithGoogle',
}

export interface OauthLoginParams {
  id_token: string;
  provider: string;
  returning_url: string;
}

export interface CreateLeadWithOauthParams {
  declined_opt_in: boolean;
  form_location: string;
  id_token: string;
  lead_type: string;
  newsletter_ids?: number[];
  opt_in_required: boolean;
  page: string;
  provider: string;
  redirect_to_on_success: string;
}

export interface UnlockContentWithOauthParams {
  article_id: number;
  briefing_guid: string;
  form_location: string;
  id_token: string;
  lead_type: string;
  newsletter_ids?: number[];
  opt_in_required: boolean;
  page: string;
  provider: string;
  share_guid: string;
  user: {
    declined_opt_in: boolean;
  };
}

interface OauthLoginResponse {
  redirect_url: string;
}

interface OauthCreateLeadResponse {
  isNewUser: boolean;
  location: string;
  message: string;
  userId: number;
}

interface OauthUnlockContentResponse {
  location: string;
  new_lead?: boolean;
}

export const GOOGLE_PROVIDER = 'google';
export const APPLE_PROVIDER = 'apple';

export const logInWithOauth = async (params: OauthLoginParams): Promise<OauthLoginResponse> => {
  const response = await request('post', create_session_with_oauth_path(params));
  return response;
};

export const createLeadWithOauth = async (
  params: CreateLeadWithOauthParams
): Promise<OauthCreateLeadResponse> => {
  const response = await request('post', create_lead_with_oauth_path(params));
  return response;
};

export const unlockContentWithOauth = async (
  params: UnlockContentWithOauthParams
): Promise<OauthUnlockContentResponse> => {
  const response = await request('post', unlock_content_with_oauth_path(params));
  return response;
};
